import React, { Fragment } from 'react';
import Breadcrumbs from '../../../CommonElements/Breadcrumbs';
import UsersEditContain from '../../../Component/Firms/AddFirm';
import { useTranslation } from 'react-i18next';

const UsersEdit = () => {
  const { t } = useTranslation();
  return (
    <Fragment>
      <Breadcrumbs parent={t("Firms")} title={t("Add Firm")} />
      <UsersEditContain />
    </Fragment>
  );
};
export default UsersEdit;
